import { render, staticRenderFns } from "./RatingPreview.vue?vue&type=template&id=fd74da94&scoped=true&"
import script from "./RatingPreview.vue?vue&type=script&lang=js&"
export * from "./RatingPreview.vue?vue&type=script&lang=js&"
import style0 from "./RatingPreview.vue?vue&type=style&index=0&id=fd74da94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd74da94",
  null
  
)

export default component.exports